var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseListV2',{attrs:{"model-class":_vm.Group,"collection-filter":_vm.filter,"help-message":'A group defines a set of users. Groups are used to grant permissions to users.'}})}
var staticRenderFns = []

export { render, staticRenderFns }